import React, { useState } from 'react';
import { Container, Paper, Typography, TextField, Button, Alert, Box } from '@mui/material';
import { forgotPassword } from '../api/client';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await forgotPassword(email);
        setMessage(res.message);
        setLoading(false);
    };

    return (
        <Container maxWidth="xs" sx={{ py: 8 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                <Typography variant="h5" align="center" gutterBottom fontWeight="bold">
                    Reset Password
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                    Enter your email to receive a reset link.
                </Typography>

                {message && <Alert severity="info" sx={{ mb: 2 }}>{message}</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth label="Email Address" type="email"
                        value={email} onChange={e => setEmail(e.target.value)}
                        required margin="normal"
                    />
                    <Button
                        type="submit" fullWidth variant="contained"
                        size="large" sx={{ mt: 2 }} disabled={loading}
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default ForgotPasswordPage;
